import {AxiosError} from 'axios';
import {ApiErrorDTO} from './types';
import {getLocalisedErrorCode} from '../i18n/getLocalisedErrorCode';

export class ApiError extends Error {
  status = 0;
  data?: ApiErrorDTO = undefined;
  cause: Error;
  code?: string = undefined;
  needLogin = false;

  constructor(error: AxiosError) {
    super();

    if (error.response) {
      this.status = error.response.status;
      this.data = error.response.data;
      this.code = error.response.data?.error_code;
      this.message = getLocalisedErrorCode(this.code);
      if (this.status === 401) {
        this.needLogin = true;
      }
    } else {
      this.message = error.message;
    }
    this.cause = error;
  }

  setMessage(message: string) {
    this.message = message;
  }

  toString() {
    if (this.data && this.data.errorCode) {
      return `Error ${this.status}: ${this.data.errorCode}, ${this.data.message}`;
    }
    return 'Error: ' + this.message;
  }
}
